import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';

import { concatWithDot } from 'helpers/string';

import { KEY_ASSUMPTIONS_NAMES, prefix } from '../utils/form';

export const ExpensesAssumptions: FC<{ disabled: boolean }> = ({ disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.costFormation')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_FORMATION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_FORMATION)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_FORMATION)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.expenses')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPENSES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPENSES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.EXPENSES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.costsInfluenceFactors')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COSTS_INFLUENCE_FACTORS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COSTS_INFLUENCE_FACTORS)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COSTS_INFLUENCE_FACTORS)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.costEstimation')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_ESTIMATION)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_ESTIMATION)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.COST_ESTIMATION)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.logisticsAffect')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.LOGISTICS_AFFECT)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.LOGISTICS_AFFECT)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.LOGISTICS_AFFECT)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.fixedCostsDistributing')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_COSTS_DISTRIBUTING)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_COSTS_DISTRIBUTING)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_COSTS_DISTRIBUTING)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.researchMainComponents')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.RESEARCH_MAIN_COMPONENTS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.RESEARCH_MAIN_COMPONENTS)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.RESEARCH_MAIN_COMPONENTS)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.highestPriorityProjects')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.HIGHEST_PRIORITY_PROJECTS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.HIGHEST_PRIORITY_PROJECTS)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.HIGHEST_PRIORITY_PROJECTS)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.mainCostComponents')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.MAIN_COST_COMPONENTS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.MAIN_COST_COMPONENTS)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.MAIN_COST_COMPONENTS)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.generalStructure')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.GENERAL_STRUCTURE)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.GENERAL_STRUCTURE)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.GENERAL_STRUCTURE)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.otherOperatingExpenses')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.OTHER_OPERATING_EXPENSES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.OTHER_OPERATING_EXPENSES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.OTHER_OPERATING_EXPENSES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.controlStrategies')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CONTROL_STRATEGIES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CONTROL_STRATEGIES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.CONTROL_STRATEGIES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.fixedExpensesTypes')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_EXPENSES_TYPES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_EXPENSES_TYPES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FIXED_EXPENSES_TYPES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.financialExpensesAmount')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FINANCIAL_EXPENSES_AMOUNT)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FINANCIAL_EXPENSES_AMOUNT)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.FINANCIAL_EXPENSES_AMOUNT)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.nonOperatingAmount')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.NON_OPERATING_EXPENSES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.NON_OPERATING_EXPENSES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.NON_OPERATING_EXPENSES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={disabled}
        title={t('financialPlan.keyAssumptions.typesOfTaxes')}
        aiFieldName={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.TYPES_OF_TAXES)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.TYPES_OF_TAXES)}
          name={concatWithDot(prefix, KEY_ASSUMPTIONS_NAMES.TYPES_OF_TAXES)}
          minRows={4}
          disabled={disabled}
        />
      </FormSectionCard>
    </>
  );
};
